export class SquadNumberDto {
    teamId: number;
    playerId: number;
    number: number;
}